import { render, staticRenderFns } from "./PasswordConfirmPage.vue?vue&type=template&id=7f1f0a65&scoped=true&"
import script from "./PasswordConfirmPage.vue?vue&type=script&lang=ts&"
export * from "./PasswordConfirmPage.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordConfirmPage.vue?vue&type=style&index=0&id=7f1f0a65&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_lodash@4.17.21_prettier@3.0.1_vue-template-compiler@2.7.14_webpack@5.88.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1f0a65",
  null
  
)

export default component.exports